export interface ITrackEvent {
  trackId: string;
  trackProgress?: number;
  trackPosition?: number;
  trackDuration?: number;
}
